var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumberWithIndicator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.698,
    height: 85,
    viewBox: "0 0 96.698 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1958",
    "data-name": "Group 1958",
    transform: "translate(-39.379 -102.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1782",
    "data-name": "Group 1782",
    transform: "translate(-1216.425 -405.348)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "#",
    transform: "translate(1255.804 575.306)",
    fill: "#575757",
    fontSize: 63,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "#")), /*#__PURE__*/React.createElement("g", {
    id: "Group_1673",
    "data-name": "Group 1673",
    transform: "translate(1305.82 530.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    transform: "translate(7.502 7.502)",
    fill: "none",
    stroke: "#575757",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.838,
    cy: 15.838,
    r: 15.838,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.838,
    cy: 15.838,
    r: 13.838,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_860",
    "data-name": "Line 860",
    y2: 46.682,
    transform: "translate(23.341 0)",
    fill: "none",
    stroke: "#575757",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_862",
    "data-name": "Line 862",
    x2: 46.682,
    transform: "translate(0 23.341)",
    fill: "none",
    stroke: "#575757",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_861",
    "data-name": "Line 861",
    transform: "translate(38.346 0)",
    fill: "none",
    stroke: "#575757",
    strokeWidth: 4
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberWithIndicator);
export default __webpack_public_path__ + "static/media/numberWithIndicator.26e2b6421523daa1aef4c0d397f6c586.svg";
export { ForwardRef as ReactComponent };